export default "__VITE_ASSET__CHrwf_Zm__"